import { useTranslation } from 'react-i18next';
import * as S from './MyAdsBulkPromotion.styles';
import type { BulkPromotionPaymentReceipt } from '@/features/Profile/sections/MyAds/hooks';
import { Modal } from '@/components/UI/Modal';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { Button } from '@/components/UI/Button/Button';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { ROUTES } from '@/constants/routes';
import { ProfilePageTestIds } from '@/__e2e__/testIds/profile-page';

type Props = {
  payment: BulkPromotionPaymentReceipt | null;
  onClose: () => void;
};

export function MyAdsBulkPromotionSuccessModal({ payment, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <Modal
      isInPortal
      isScrollLocked
      isOpen={Boolean(payment)}
      onClose={onClose}
      dataTestId={ProfilePageTestIds.bulkPromotion.successModal}
      maxWidth={445}
      borderRadius={14}
    >
      <S.SuccessModalContent>
        <S.SuccessLogo />
        <IconBox
          $filename="check-circle-rounded.svg"
          $width={50}
          $iconWidth={50}
          $iconHeight={50}
          $height={50}
        />
        <S.SuccessTitle>
          {t('pages.cabinet.payment_receipt.success_title')}
        </S.SuccessTitle>
        <S.SuccessAmount>{payment?.amount}</S.SuccessAmount>

        <S.SuccessDetails>
          <S.SuccessDetailRow>
            <S.SuccessDetailLabel>
              {t('pages.cabinet.payment_receipt.payment_date')}
            </S.SuccessDetailLabel>
            <S.SuccessDetailValue>{payment?.paymentDate}</S.SuccessDetailValue>
          </S.SuccessDetailRow>
          <S.SuccessDetailRow>
            <S.SuccessDetailLabel>
              {t('pages.cabinet.payment_receipt.service_type')}
            </S.SuccessDetailLabel>
            <S.SuccessDetailValue>{payment?.serviceName}</S.SuccessDetailValue>
          </S.SuccessDetailRow>
          <S.SuccessDetailRow>
            <S.SuccessDetailLabel>
              {t('pages.cabinet.payment_receipt.payment_method')}
            </S.SuccessDetailLabel>
            <S.SuccessDetailValue>
              {payment?.paymentMethod}
            </S.SuccessDetailValue>
          </S.SuccessDetailRow>
        </S.SuccessDetails>

        <S.SuccessActions>
          <Button
            appearance="secondary"
            isFullWidth
            borderRadius={14}
            onClick={onClose}
          >
            {t('common.got_it')}
          </Button>
          <S.SuccessHistoryLink
            as={CustomLink}
            href={ROUTES.transactions}
            onClick={onClose}
          >
            {t('pages.cabinet.operations_history')}
          </S.SuccessHistoryLink>
        </S.SuccessActions>
      </S.SuccessModalContent>
    </Modal>
  );
}
